import { queryOrThrow, ready } from "@rootreeweb/js-lib";

import { writeText } from "./ClipboardAssistant";

const body = queryOrThrow<HTMLBodyElement>("body");
const activeClass = "rtml-helper";
const toggleID = "wp-admin-bar-rtml-helper";
const dataClass = "rtml";

/**
 * Wraps the value of the data element with the shortcode and writes it to the
 * clipboard.
 *
 * @param e The click event.
 * @param elem The data element.
 */
function handleDataClick(e: Event, elem: HTMLDataElement) {
	if (!body.classList.contains(activeClass)) {
		return;
	}
	e.preventDefault();
	writeText(elem.value);
}

ready(() => {
	const container = document.getElementById(toggleID);

	const toggle = container?.querySelector("a");
	if (!toggle) {
		return;
	}

	toggle.addEventListener("click", (e) => {
		e.preventDefault();
		body.classList.toggle(activeClass);
	});

	const dataElems = document.querySelectorAll<HTMLDataElement>(dataClass);
	for (const elem of dataElems) {
		elem.addEventListener("click", (e) => {
			handleDataClick(e, elem);
		});
	}
});
